import React from 'react';
import { connect } from 'react-redux';

import { setHistoryPanel } from '../../actions/panels';
import ReorderIndividualItem from './ReorderIndividualItem';
import { cartReset, cartInfoUpdate, cartSetReorderLoading } from '../../actions/cart';
import { getCurrentLocation } from '../../actions/currentLocation';
import { requestEmailReceipt } from '../../actions/receipt';
import repeat from '../../assets/images/repeat-icon.svg';
import favorite from '../../assets/images/orders-icon.svg';
import unfavorite from '../../assets/images/orders-icon-unfavorite.svg';
import email from '../../assets/images/email-icon.svg';
import { ModalCloseButton } from '../common/ModalCloseButton';

import { toggleOrderTagged, receiptLoading } from '../../actions/receipt';


class ReorderItemDetails extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            orderItem: {}
        }
    }

    sendEmailReceipt(order_id){

        const { token, dispatch } = this.props;

        const params = {
            order_id,
            token
        };

        dispatch(requestEmailReceipt(params));
    }

    renderReorderItem(items, scope) {
        return items.map((theItem, theIndex) => (
            <ReorderIndividualItem
                key={scope+"-"+theIndex}
                index={theIndex}
                item={theItem}
                scope={scope}
            />
        ));
    }

    renderReorderItems() {
        
        if (this.props.orderItem.order_information) {

            const {
                pizzas,
                foodItems,
                addons,
                beverages,
                specials
            } = this.props.orderItem.order_information;
        
            // get the specials to render
            const renderSpecials = this.renderReorderItem(specials, 'special');
        
            // get the pizzas to render
            const renderPizzas = this.renderReorderItem(pizzas, 'pizza');
        
            // get the food items to render
            const renderFoodItems = this.renderReorderItem(foodItems, 'fooditem');
        
            // get the beverages to render
            const renderBeverages = this.renderReorderItem(beverages, 'beverage');
        
            // get the beverages to render
            const renderAddons = this.renderReorderItem(addons, 'addon');
        
            return [renderSpecials, renderPizzas, renderFoodItems, renderBeverages, renderAddons];
        }
    }

    renderReorderTotals() {

        if (this.props.orderItem.order_information) {
            return (
                <div>
                    <div className="view-reorder-item">
                        <div className="padding">
                        </div>         
                        <div className="wrapper-small">
                            <p className="item-label">Subtotal: {this.props.orderItem.subtotal}</p>
                            
                        </div>
                    </div>
                    {(parseFloat(this.props.orderItem.promo_total) > 0) && (
                        <div className="view-reorder-item">
                            <div className="padding">
                            </div>         
                            <div className="wrapper-medium">
                                <p className="item-label" >Promo Discount: {this.props.orderItem.promo_total}</p>
                            </div>
                        </div>
                    )}
                    {(parseFloat(this.props.orderItem.loyalty_redeem_amount) > 0) && (

                          <div className="view-reorder-item">
                            <div className="padding">
                            </div>         
                                <div className="wrapper-medium">
                                    <p className="item-label">Loyalty Points Discount: {this.props.orderItem.loyalty_redeem_amount}</p>
                                 
                                </div>
                            </div>
                    )}
                    <div className="view-reorder-item">
                        <div className="padding">
                        </div>         
                        <div className="wrapper-small">
                            <p className="item-label">Taxes: {this.props.orderItem.taxes}</p>
          
                        </div>
                    </div>
                    {(this.props.orderItem.order_type == "delivery") && (
                        <div className="view-reorder-item">
                        <div className="padding">
                        </div>         
                        <div className="wrapper-small">
                            <p className="item-label">Delivery: {this.props.orderItem.delivery_charge}</p>
                          
                        </div>
                    </div>
                    )}
                    {(this.props.orderItem.fuel_surcharge && parseFloat(this.props.orderItem.fuel_surcharge) > 0) && (
                          <div className="view-reorder-item">
                          <div className="padding">
                          </div>         
                          <div className="wrapper-medium">
                              <p className="item-label">Service Fee: {this.props.orderItem.fuel_surcharge}</p>
                             
                          </div>
                      </div>
                    )}
                    {(parseFloat(this.props.orderItem.tip_amount) > 0) && (
                          <div className="view-reorder-item">
                          <div className="padding">
                          </div>         
                          <div className="wrapper-small">
                              <p className="item-label">Tip: {this.props.orderItem.tip_amount}</p>
                             
                          </div>
                      </div>
                    )}
                    <div className="view-reorder-item">
                        <div className="padding">
                        </div>         
                        <div className="wrapper-medium">
                            <p className="item-label">Additional Charge: {this.props.orderItem.additional_charge}</p>
                         
                        </div>
                    </div>

                    <div className="view-reorder-item">
                        <div className="padding">
                        </div>         
                        <div className="wrapper-small">
                            <p className="total">Total: {this.props.orderItem.total}</p>
                        
                        </div>
                    </div>
                </div>
            );
        }
    }

    deleteOrderConfirm(){

        var retVal = confirm("Are you sure you want to untag this order?");

        if(retVal){
            this.tagOrderToggle();
        }

    }

    tagOrderToggle(){
        let item = this.props.orderItem;

        const { token } = this.props;

        const params = {
            item: item,
        };

        this.props.dispatch(receiptLoading());
        this.props.dispatch(toggleOrderTagged(item.id, item.tagged, token, this.props.orderHistory));
    }

    handleTagClick(){
        if(this.props.orderItem.tagged == 1){
            this.deleteOrderConfirm();
        }else{
            this.tagOrderToggle();
        }
    }

    getOrderImage(){
        return (this.props.orderItem.tagged == 1) ? unfavorite: favorite;
    }

    getOrderText(){
        return (this.props.orderItem.tagged == 1) ? "Remove from your usual orders": "Make this one of your usual orders";
    }

    render() {
        if (this.props.tagLoading) {
            return (
                <LoadingSpinner />
            );
        }
        else {
            return (
                <div>
                    <div className="close-button">
                        <ModalCloseButton 
                            clickAction={() => this.props.dispatch(setHistoryPanel('list'))} 
                        />
                    </div>
                    <div className="reorder-item-details-bottom-margin">    
                        <div className="past-order-wrapper">
                            <h2 className="heading in-item">{this.props.orderItem.order_date}</h2>
                            <h3 className="h3-header no-top-pad">{this.props.orderItem.restaurant_name}</h3>
                        </div>
                        {this.renderReorderItems()}
                        {this.renderReorderTotals()}
                            <div className="reorder-buttons-wrapper">
    
                                {(this.props.logged_in) && (
                                <div className="account-button in-receipt email-receipt"
                                     onClick={() => this.sendEmailReceipt(this.props.orderItem.id)}
                                >
                                    <img src={email} loading="lazy" className="button-icon white" />
                                    <div>Email me this receipt</div>
                                </div>)}
                                {(this.props.logged_in) && (
                                <div className="account-button in-receipt usual-orders-history"
                                    onClick={() => this.handleTagClick()}
                                >
                                    <img src={this.getOrderImage()} loading="lazy" className="button-icon white" />
                                    <div>{this.getOrderText()}</div>
                                </div>)}
                                {(this.props.logged_in) && (
                                <div className="account-button in-receipt logout-history"
                                    onClick={() => {
                                        this.props.dispatch(cartSetReorderLoading(true));
                                        // reset and load all required information into the cart
                                        this.props.dispatch(cartReset());
                                        // make sure that we set up the user's information in their cart into
                                        this.props.dispatch(cartInfoUpdate({prop: 'name', value: (this.props.orderItem.name).trim()}));
                                        this.props.dispatch(cartInfoUpdate({prop: 'phone', value: this.props.orderItem.phone}));
                                        this.props.dispatch(cartInfoUpdate({prop: 'email', value: this.props.orderItem.email}));
                                        this.props.dispatch(cartInfoUpdate({prop: 'order_type', value: this.props.orderItem.order_type}));
                                        if (this.props.orderItem.order_type == "delivery") {
                                            this.props.dispatch(cartInfoUpdate({prop: 'address', value: this.props.orderItem.address}));
                                        }
                                        // load the location, add the items for reorder, and redirect to the cart
                                        this.props.dispatch(getCurrentLocation(this.props.orderItem.location_id, true, this.props.history, this.props.orderItem.reorder_information));
                                        // go to the next screen
                                    }}
                                >
                                    <img src={repeat} loading="lazy" className="button-icon white" />
                                     <div>Order This Again!</div>
                                </div>)}
                            </div>
                    </div>
                </div>
            );
        }
        
    }
}

const mapStateToProps = (state) => {

    return {
        loading: state.cart.reorder_loading,
        tagLoading: state.receipt.loading,
        token: state.auth.token,
        orderHistory: state.auth.user.orderHistory,
        logged_in: state.auth.logged_in,
        loggedUser: state.auth.user,
        cart: state.cart,
        currentLocation: state.currentLocation.info
    };
};

export default connect(mapStateToProps)(ReorderItemDetails);
